module.exports = __webpack_public_path__ + "static/media/teton_glacier.17b78a45.jpeg";